(function(){
  'use strict';
  var GHOST='.pcard-label--ghost';
  var REAL='.pcard-label--above:not(.pcard-label--ghost)';

  function itemOf(el){
    return el.closest('.grid__item, li') || el.parentElement;
  }

  function gridOf(el){
    var item = itemOf(el);
    return (item && item.parentElement) || null;
  }

  function apply(scope){
    var root=scope||document;
    var ghosts=[].slice.call(root.querySelectorAll(GHOST));
    if(!ghosts.length)return;

    ghosts.forEach(function(g){g.classList.remove('is--row-empty');});

    var grids=new Set();
    ghosts.forEach(function(g){
      var grid=gridOf(g);
      if(grid&&grid.children&&grid.children.length>1)grids.add(grid);
    });

    grids.forEach(function(grid){
      var items=[].slice.call(grid.children);
      var rows={};
      items.forEach(function(it){
        if(it.offsetParent===null&&it.offsetHeight===0)return;
        var key=Math.round(it.offsetTop/4)*4;
        (rows[key]=rows[key]||[]).push(it);
      });
      Object.keys(rows).forEach(function(k){
        var row=rows[k];
        var hasReal=row.some(function(it){var r=it.querySelector(REAL);return !!(r&&r.offsetHeight>0&&(r.textContent.trim()||r.querySelector('img')));});
        if(hasReal)return;
        row.forEach(function(it){
          [].forEach.call(it.querySelectorAll(GHOST),function(g){g.classList.add('is--row-empty');});
        });
      });
    });

    ghosts.forEach(function(g){
      if(g.classList.contains('is--row-empty'))return;
      var card=g.parentElement;
      var src=card&&(card.querySelector(':scope > .card__inner')||card.querySelector('.card__inner'));
      var bg='';
      while(src&&src!==card){
        var c=getComputedStyle(src).backgroundColor;
        if(c&&c!=='transparent'&&c!=='rgba(0, 0, 0, 0)'){bg=c;break;}
        src=src.querySelector('.card__media, .media')||null;
      }
      if(bg)g.style.setProperty('--ghost-bg',bg);
    });
  }

  function cardHasTop(inner){
    return !!inner.querySelector('.pcard-label--c-top-left, .pcard-label--c-top-right');
  }
  function near(el){
    var vh=window.innerHeight||800;
    var b=el.getBoundingClientRect();
    return b.bottom>-vh&&b.top<vh*2.5;
  }
  function compactTop(){
    var inners=document.querySelectorAll('.product-card-wrapper .card--standard .card__inner');
    var groups=new Map();
    for(var i=0;i<inners.length;i++){
      var inner=inners[i];
      var item=itemOf(inner);
      if(!item||(item.offsetParent===null&&item.offsetHeight===0))continue;
      if(!near(item))continue;
      var grid=item.parentElement;
      var key=Math.round(item.offsetTop/4)*4;
      var g=groups.get(grid);
      if(!g){g={};groups.set(grid,g);}
      (g[key]=g[key]||[]).push(inner);
    }
    groups.forEach(function(rows){
      Object.keys(rows).forEach(function(k){
        var row=rows[k];
        var keep=row.some(cardHasTop);
        row.forEach(function(inner){
          var want=keep?'':'0px';
          if(inner.style.paddingTop!==want)inner.style.paddingTop=want;
        });
      });
    });
  }
  function alignExternal(){
    var cards=document.querySelectorAll('.product-card-wrapper');
    var groups=new Map();
    for(var i=0;i<cards.length;i++){
      var item=cards[i].closest('.grid__item');
      if(!item||(item.offsetParent===null&&item.offsetHeight===0))continue;
      if(!near(item))continue;
      var top=cards[i];
      while(top.parentElement&&top.parentElement!==item)top=top.parentElement;
      if(top.parentElement!==item)continue;
      var grid=item.parentElement;
      var key=Math.round(item.offsetTop/4)*4;
      var g=groups.get(grid);
      if(!g){g={};groups.set(grid,g);}
      var el=top;
      if(getComputedStyle(top).display==='inline')el=cards[i];
      var cur=parseFloat(el.style.marginTop)||0;
      var off=el.getBoundingClientRect().top-item.getBoundingClientRect().top-cur;
      (g[key]=g[key]||[]).push({el:el,off:off});
    }
    groups.forEach(function(rows){
      Object.keys(rows).forEach(function(k){
        var row=rows[k];
        var max=0;
        row.forEach(function(r){if(r.off>max)max=r.off;});
        row.forEach(function(r){
          var d=Math.round(max-r.off);
          var want=d>0?d+'px':'';
          if(r.el.style.marginTop!==want)r.el.style.marginTop=want;
        });
      });
    });
  }
  function alignBoost(){
    var links=document.querySelectorAll('.boost-sd__product-item .boost-sd__product-link-image');
    var groups=new Map();
    for(var i=0;i<links.length;i++){
      var lk=links[i];
      var item=lk.closest('.boost-sd__product-item');
      var lay=lk.parentElement;
      if(!item||!lay||(item.offsetParent===null&&item.offsetHeight===0))continue;
      if(!near(item))continue;
      var ir=item.getBoundingClientRect();
      var grid=item.parentElement;
      var key=Math.round(ir.top/4)*4;
      var g=groups.get(grid);
      if(!g){g={};groups.set(grid,g);}
      var ref=lk.querySelector('.boost-sd__product-image-wrapper')||lk;
      var cur=parseFloat(lk.style.marginTop)||0;
      var off=ref.getBoundingClientRect().top-ir.top-cur;
      (g[key]=g[key]||[]).push({el:lk,off:off});
    }
    groups.forEach(function(rows){
      Object.keys(rows).forEach(function(k){
        var row=rows[k];
        var max=0;
        row.forEach(function(r){if(r.off>max)max=r.off;});
        row.forEach(function(r){
          var d=Math.round(max-r.off);
          var want=d>0?d+'px':'';
          if(r.el.style.marginTop!==want)r.el.style.marginTop=want;
        });
      });
    });
  }
  var RSEL='.card-inner-rating, .boost-sd__rating-badge, .boost-sd__custom-rating-badge';
  var LSEL='.pcard-label:not(.pcard-label--ghost), .card__badge, .product_badge, .pl-container, .pl-collection, .poco-blabel:not(.poco-bghost), .food_main_badge, .deco-badge-stack, [class*="badge"]:not(.card-inner-rating):not(.boost-sd__rating-badge):not(.boost-sd__custom-rating-badge):not(.wl-count-badge)';
  function placeRatings(){
    var list=document.querySelectorAll(RSEL);
    var jobs=[];
    for(var i=0;i<list.length;i++){
      var rt=list[i];
      var host=rt.offsetParent;
      if(!host||!near(host))continue;
      var rr=rt.getBoundingClientRect();
      var hr=host.getBoundingClientRect();
      if(!rr.height||!hr.height)continue;
      var curB=parseFloat(getComputedStyle(rt).bottom)||0;
      if(rt.dataset.rb0===undefined||!rt.style.getPropertyValue('bottom'))rt.dataset.rb0=curB;
      var shift=curB-parseFloat(rt.dataset.rb0);
      var top=rr.top+shift,bot=rr.bottom+shift,left=rr.left,right=rr.right;
      var labs=host.querySelectorAll(LSEL);
      var minTop=bot;
      for(var k=0;k<labs.length;k++){
        var n=labs[k];
        if(n===rt||rt.contains(n)||n.contains(rt))continue;
        var r=n.getBoundingClientRect();
        if(!r.width||!r.height||r.height>hr.height*0.4)continue;
        if(r.right<=left||r.left>=right||r.bottom<=top||r.top>=bot)continue;
        var cs=getComputedStyle(n);
        if(cs.visibility==='hidden'||cs.opacity==='0'||cs.display==='none')continue;
        if(r.top<minTop)minTop=r.top;
      }
      jobs.push({el:rt,want:minTop<bot?Math.round(parseFloat(rt.dataset.rb0)+bot-minTop+4)+'px':''});
    }
    for(var j=0;j<jobs.length;j++){
      var jb=jobs[j];
      if(jb.want){
        if(jb.el.style.getPropertyValue('bottom')!==jb.want)jb.el.style.setProperty('bottom',jb.want,'important');
      }else if(jb.el.style.getPropertyValue('bottom')){
        jb.el.style.removeProperty('bottom');
      }
    }
  }
  function fitLabels(){
    var list=document.querySelectorAll('.card .pcard-label[class*="pcard-label--c-"], .boost-sd__product-item .poco-blabel:not(.pcard-label--above)');
    var todo=[];
    for(var i=0;i<list.length;i++){
      var l=list[i];
      if(l.querySelector('img')||!l.offsetParent)continue;
      if(!near(l))continue;
      todo.push(l);
    }
    for(var j=0;j<todo.length;j++)todo[j].style.setProperty('--lbl-fit','1');
    var res=[];
    for(var k=0;k<todo.length;k++){
      var e=todo[k];
      var cw=e.clientWidth,sw=e.scrollWidth;
      res.push(sw>cw&&cw>0?Math.max(0.5,Math.floor(cw/sw*100)/100):1);
    }
    for(var m=0;m<todo.length;m++){
      if(res[m]<1)todo[m].style.setProperty('--lbl-fit',String(res[m]));
    }
  }
  function placeDots(){
    fitLabels();
    compactTop();
    alignExternal();
    alignBoost();
    placeRatings();
    var list=document.querySelectorAll('.card-dots');
    var jobs=[];
    for(var i=0;i<list.length;i++){
      var dots=list[i];
      var host=dots.offsetParent;
      if(!host||!near(host))continue;
      var card=dots.closest('.card')||host;
      var media=card.querySelector('.card__media');
      if(!media)continue;
      var hr=host.getBoundingClientRect();
      var mr=media.getBoundingClientRect();
      if(!hr.height||!mr.height)continue;
      var limit=mr.bottom-8;
      var labs=card.querySelectorAll('.pcard-label:not(.pcard-label--ghost):not(.pcard-label--above), .product_badge, .pl-container, .pl-collection, .food_main_badge');
      for(var k=0;k<labs.length;k++){
        var r=labs[k].getBoundingClientRect();
        if(!r.height||r.height>mr.height*0.4)continue;
        if(r.bottom<mr.bottom-4||r.top>mr.bottom)continue;
        if(r.top-6<limit)limit=r.top-6;
      }
      jobs.push({el:dots,b:Math.max(0,Math.round(hr.bottom-limit))+'px'});
    }
    for(var j=0;j<jobs.length;j++){
      var d=jobs[j].el,st=d.style;
      if(st.getPropertyValue('bottom')===jobs[j].b&&d.dataset.dotsSet==='1')continue;
      d.dataset.dotsSet='1';
      st.setProperty('left','0','important');
      st.setProperty('right','0','important');
      st.setProperty('top','auto','important');
      st.setProperty('justify-content','center','important');
      st.setProperty('padding','0','important');
      st.setProperty('bottom',jobs[j].b,'important');
    }
  }
  var dr=0;
  function queueDots(){
    if(dr)return;
    dr=requestAnimationFrame(function(){dr=0;placeDots();});
  }

  var t;
  var first=0;
  function schedule(scope){
    var now=Date.now();
    if(!first)first=now;
    if(t&&now-first>=400)return;
    clearTimeout(t);
    var wait=Math.min(120,Math.max(0,400-(now-first)));
    t=setTimeout(function(){t=0;first=0;apply(scope);queueDots();},wait);
  }

  function boot(){apply();queueDots();}

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot);
  }else{
    boot();
  }
  window.addEventListener('load',function(){schedule();});
  window.addEventListener('resize',function(){schedule();});
  var sc=0;
  window.addEventListener('scroll',function(){
    if(sc)return;
    sc=setTimeout(function(){sc=0;queueDots();},200);
  },{passive:true});
  document.addEventListener('shopify:section:load',function(e){schedule(e.target);});

  var REL='.product-card-wrapper, .grid__item, .card, .deco-badge-stack, .pl-container, .pl-collection, .pcard-label, .card-inner-rating, .boost-sd__product-item, .boost-sd__rating-badge, [class*="badge"]';
  var SKIPTAG=/^(SCRIPT|STYLE|LINK|META|NOSCRIPT|IFRAME|TEMPLATE)$/;
  function relevant(m){
    var a=m.addedNodes;
    if(!a||!a.length)return false;
    var t=m.target;
    if(t&&t.nodeType===1&&t.closest&&t.closest('.grid__item, .boost-sd__product-item'))return true;
    for(var i=0;i<a.length;i++){
      var n=a[i];
      if(n.nodeType!==1||SKIPTAG.test(n.tagName))continue;
      if(n.matches(REL)||n.querySelector(REL))return true;
    }
    return false;
  }
  if('MutationObserver' in window){
    var mo=new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        if(relevant(muts[i])){schedule();return;}
      }
    });
    mo.observe(document.body,{childList:true,subtree:true});
  }
  window.pocoCardLabels = {
    apply: function (scope) { apply(scope); },
    schedule: function (scope) { schedule(scope); }
  };
})();
